import { useState, useEffect } from 'react';
import {
  getRegimenesDePropiedad,
  getTipoDePredio,
  getUsosDePredio,
  getTiposDeAseos,
  getZonasDePredios,
} from 'api/catastro';
import { getEstadosDeInfracciones } from 'api/catalogos/estadosDeInfracciones';
import { getTipoDeConceptoDeInfracciones } from 'api/recaudacion/tipoDeConceptosDeInfraccion';
import { getPeriodosFiscales } from 'api/catalogos/periodosFiscales';
import { getClasesDeVehiculos } from 'api/recaudacion/clasesVehiculos';
import { getUsosDeMotocicletas } from 'api/catalogos';
import { getPermisosDeTipoDePlaca } from 'api/catalogos/permisosDeTipoDePlacas';
import { getTiposDeEstablecimientos } from 'api/empresas';
import { getMercadosDeModulos } from 'api/empresas/mercadosDeModulos';
import { getClasesDeAnuncios } from 'api/catalogos/clasesDeAnuncios';
import { getTiposDeEspacios, getTiposDeContratos, getTiposDePanteones } from 'api/recaudacion';
import { getTiposDeAnuncios } from 'api/catalogos/tiposDeAnuncios';
import { getTiposDeInfractores } from 'api/catalogos/tiposDeInfractor';

const INITIAL_STATE = {
  regimenes: [],
  usosPredio: [],
  aseoPredio: [],
  tipoPredio: [],
  zonaPredio: [],
  estadoInfraccion: [],
  tipoConcepto: [],
  periodosFiscales: [],
  clasesVehiculo: [],
  usosMotocicleta: [],
  permisosTipoPlaca: [],
  tipoEstablecimiento: [],
  mercadosModulos: [],
  clasesAnuncio: [],
  tiposEspacio: [],
  tiposContrato: [],
  tiposPanteon: [],
  tiposAnuncio: [],
  tiposInfractores: [],
};

const useCatalogos = () => {
  const [catalogs, setCatalogs] = useState(INITIAL_STATE);

  useEffect(() => {
    (async () => {
      try {
        const [
          reg, usos, aseos, tiposPred, zonas,
          estadosInf, tiposConc, periodos,
          clases, usosMoto, permisos, tiposEst,
          mercados, clasesAnun, tiposEsp,
          tiposCont, tiposPant, tiposAnun, tiposInfrac,
        ] = await Promise.all([
          getRegimenesDePropiedad(),
          getUsosDePredio(),
          getTiposDeAseos(),
          getTipoDePredio(),
          getZonasDePredios(),
          getEstadosDeInfracciones(),
          getTipoDeConceptoDeInfracciones(),
          getPeriodosFiscales(),
          getClasesDeVehiculos(),
          getUsosDeMotocicletas(),
          getPermisosDeTipoDePlaca(),
          getTiposDeEstablecimientos(),
          getMercadosDeModulos(),
          getClasesDeAnuncios(),
          getTiposDeEspacios(),
          getTiposDeContratos(),
          getTiposDePanteones(),
          getTiposDeAnuncios(),
          getTiposDeInfractores(),
        ]);

        setCatalogs({
          regimenes: reg || [],
          usosPredio: usos || [],
          aseoPredio: aseos || [],
          tipoPredio: tiposPred || [],
          zonaPredio: zonas || [],
          estadoInfraccion: estadosInf || [],
          tipoConcepto: tiposConc || [],
          periodosFiscales: periodos || [],
          clasesVehiculo: clases || [],
          usosMotocicleta: usosMoto || [],
          permisosTipoPlaca: permisos || [],
          tipoEstablecimiento: tiposEst || [],
          mercadosModulos: mercados || [],
          clasesAnuncio: clasesAnun || [],
          tiposEspacio: tiposEsp || [],
          tiposContrato: tiposCont || [],
          tiposPanteon: tiposPant || [],
          tiposAnuncio: tiposAnun || [],
          tiposInfractores: tiposInfrac || [],
        });
      } catch {
        // vacios
      }
    })();
  }, []);

  return catalogs;
};
export default useCatalogos;
